const EVENT_ID_BY_CODE: Record<string, string> = {
  AGI: '1',
  AGILWF: '2',
  AP: '3',
  PKTPI: '4',
  CD_INFO: '5',
  CD_BGD: '6',
  CD_ERR: '7',
  CD_FGD: '8',
  CS: '9',
  GADFGI: '10',
  GCS: '11',
  SB: '12',
  GGIFI: '13',
  GGIFS: '14',
  PKTPFR: '15',
  GLOCAFC: '16',
  PKTSSR: '17',
  PKTESR: '18',
  GPD: '19',
  GRFC: '20',
  GRID: '21',
  GSR: '22',
  IC: '23',
  IL: '24',
  PKTEFR: '25',
  LI: '26',
  LOS: '27',
  LO: '28',
  PKTSFR: '29',
  GRFCV2: '30',
  GCUD: '31',
  RAGI: '32',
  RGI: '33',
  S_SA: '34',
  SADFGI: '35',
  SBL: '36',
  SETSESSION: '37',
  T_SF: '38',
  SGIL: '39',
  SP: '40',
  SS: '41',
  SSFGI: '42',
  VLFI: '43',
  VLFS: '44',
  GGBFI: '45',
  GGBFS: '46',
  SN: '47',
  GNL: '48',
  DN: '49',
  GML: '50',
  UPOLL: '51',
  GPL: '52',
  SCBS: '53',
  GCBS: '54',
  SUL: '55',
  GUL: '56',
  GCLC: '57',
  SCLC: '58',
  SUS: '59',
  GUS: '60',
  SCSD: '61',
  GLOCSD: '62',
  GLP: '63',
  SLP: '64',
  GCSD: '65',
  GPI: '66',
  GNI: '67',
  T_PTO: '68',
  T_LTO: '69',
  T_LTO_TTR: '70',
  T_LTO_TTR_C: '71',
  T_LTO_VO: '72',
  T_LTO_RT: '73',
  T_LTO_CC: '74',
  T_LTO_WG: '75',
  T_LTO_WT: '76',
  T_LTO_WT_C: '77',
  T_LTO_WU: '78',
  T_ATO: '79',
  T_PRTO: '80',
  T_MTO: '81',
  T_LBTO: '82',
  S_LBTO: '83',
  S_NTO: '84',
  S_NTO_TMP: '85',
  S_NTO_JO: '86',
  S_NTO_WBO: '87',
  S_NTO_CNO: '88',
  S_NTO_PO: '89',
  S_ATO: '90',
  THS_TTS: '91',
  THS_TR: '92',
  THS_PD: '93',
  THS_D: '94',
  T_LTO_PE_P: '95',
  T_LTO_PE_E: '96',
  T_MO_A: '97',
  T_MO_AU: '98',
  T_MO_N: '99',
  T_CCO: '100',
  T_SS_AH: '101',
  T_SS: '102',
  T_SB: '103',
  T_LTO_MS: '104',
  ABFC: '105',
  GSD: '106',
  SSD: '107',
  GGBFIV2: '108',
  GGAD: '109',
  GNLV2: '110',
  GSTI: '111',
  GSBRWR: '112',
  GSBRDR: '113',
  GITWC: '114',
  GGBFSV2: '115',
  GGNADFS: '116',
  PKTOFR: '117',
  PKTOFSCR: '118',
  PKTOFGSD: '119',
  GTI: '120',
  GLPS: '121',
  GLPDFC: '122',
  GCUL: '123',
  SCFN: '124',
  S_ATO_IR_O: '125',
  S_ATO_IR_F: '126',
  S_ATO_IR_B: '127',
  S_ATO_IR_AS: '128',
  S_ATO_IR_AP: '129',
  S_ATO_IR_Q: '130',
  S_ATO_IR_DND_SEL: '131',
  S_ATO_IR_DND_SUB: '132',
  S_ATO_IR_HL_SEL: '133',
  S_ATO_IR_HL_SUB: '134',
  S_ATO_IR_SW_SUB: '135',
  S_ATO_IR_SW_FB_REC: '136',
  S_ATO_IR_SW_FB_REC_O: '137',
  S_ATO_IR_T_SUB: '138',
  S_ATO_IR_CRTL_SUB: '139',
  S_ATO_IR_CLO: '140',
  GBCD: '141',
  SBC: '142',
  CV_L: '143',
  CV_P_CU: '144',
  CV_P_L: '145',
  CV_P_I: '146',
  CV_P_D: '147',
  CV_PG_CU: '148',
  CV_PG_L: '149',
  CV_PG_I: '150',
  CV_PG_D: '151',
  CV_G_CU: '152',
  CV_G_L: '153',
  CV_G_I: '154',
  CV_G_D: '155',
  CV_D_AUP: '156',
  CV_D_L: '157',
  CV_D_I: '158',
  CV_S_L: '159',
  CV_C_CU: '160',
  CV_C_L: '161',
  CV_C_I: '162',
  CV_C_D: '163',
  CV_C_SU: '164',
  CV_C_S: '165',
  CV_CR_L: '166',
  CV_CR_L_CSV: '167',
  CV_CR_U: '168',
  CV_CR_MU: '169',
  CV_CR_D: '170',
  CV_CR_R: '171',
  CV_GSCL: '172',
  CV_GSC: '173',
  CV_SSC: '174',
  CV_DSC: '175',
  CV_U_CU: '176',
  CV_U_L: '177',
  CV_U_I: '178',
  CV_AU_L: '179',
  CV_AUSD: '180',
  CV_DSD: '181',
  CV_GSD: '182',
  CV_GASD: '183',
  CV_SM: '184',
  CV_GML: '185',
  CV_DM: '186',
  CV_DS_CU: '187',
  CV_DS_L: '188',
  CV_DS_D: '189',
  CV_DS_I: '190',
  CV_UBU_CSV: '191',
  CV_UBU_CSV_QC: '192',
  CV_CBUV: '193',
  CV_CBUV_QC: '194',
  CV_CSBU: '195',
  R_GDL: '196',
  R_SUBS: '197',
  R_CUU: '198',
  R_CUIB: '199',
  R_GUBS: '200',
  R_CUNA: '201',
  R_VP: '202',
  GCL: '203',
  SCSET: '204',
  GCSET: '205',
  SCCSET: '206',
  GCW: '207',
  SCW: '208',
  CAASGI: '209',
  SII: '210',
  SBRF: '211',
  GBRF: '212',
  ISUS: '213',
  IGUS: '214',
  GISM: '215',
  RUB: '216',
  GLRB: '217',
  GDL: '218',
  GUFBFAB: '219',
  CV_UELC: '220',
  CV_FASRELC: '221',
  CV_GDSFE: '222',
  CV_VES: '223',
  CV_CEC: '224',
  CV_GLEC: '225',
  GRB: '226',
  R_GOI: '227',
  GII: '228',
  CV_DCU: '229',
  CV_CCWMU: '230',
  CV_CMCWOS: '231',
  CV_MCR_L_CSV: '232',
  CV_CFMOU: '233',
  T_OTO: '234',
  T_PRGTO: '235',
  T_PRGTO_A: '236',
  T_PRGTO_G: '237',
  T_PRGTO_R: '238',
  T_PRGTO_S: '239',
  T_STO: '240',
  T_SNTO: '241',
  S_DTO: '242',
  S_RTO: '243',
  S_RTO_SUB: '244',
  S_CTO: '245',
  S_LBTO_RC: '246',
  S_LBTO_RW: '247',
  S_LBTO_RS: '248',
  S_LBTO_BII_SUB: '249',
  S_LBTO_MII_SUB: '250',
  S_LBTO_EII_SUB: '251',
  CV_RDUAC: '252',
  SCP: '253',
  CV_OUL: '254',
  VLFS_SAML: '255',
  VLFI_SAML: '256',
  CV_L_SAML: '257',
  CV_DN_PC: '258',
  GPCL: '259',
  GCI: '260',
  GPGL: '261',
  UPCN: '262',
  UCFELC: '263',
  GGL: '264',
  RCD: '265',
  CV_CCD: '266',
  CV_GDSSOL: '267',
  CV_DL: '268',
  CV_UBCCD_CSV: '269',
  CV_CSBCCD_CSV: '270',
  CV_D_S_R: '271',
  SCG: '272',
  GLG: '273',
  DCG: '274',
  SIFCG: '275',
  STAFCG: '276',
  GDIRL: '277',
  SDIRL: '278',
  CFGIASFWC: '279',
  PAEDCED: '280',
  CV_CFAL20CE: '281',
  CV_PG_I_BY_RPID: '282',
  GPKTCSFD: '283',
  SPKTCFA: '284',
  GPKTCFA: '285',
  CV_ULAA: '286',
  EXS: '287',
  S_PKT_SCS: '288',
  T_PKT_SCS: '289',
  T_GTO: '290',
  T_GTO_GR_ADD: '291',
  T_GTO_GR_EDT: '292',
  T_GTO_GR_REM: '293',
  T_GTO_CT_ADD: '294',
  T_GTO_CT_REM: '295',
  T_GTO_GR_ACT: '296',
  T_GTO_GR_DEACT: '297',
  GSFOFSIGI: '298',
  SSFOFSIGI: '299',
  UCI: '300',
  GRFSC: '301',
  CV_EV_SE: '302',
  CV_EV_VE: '303',
  CV_RS_GA: '304',
  CV_RS_A: '305',
  CV_RS_R: '306',
  CV_NIU_CU: '307',
  R_GDPL: '308',
  R_GDPD: '309',
  R_GDLDBI: '310',
  HBT_DL: '311',
  GHB_DL: '312',
};

const LRS_VERB_IDS = new Set([
  '3',
  '9',
  '23',
  '24',
  '26',
  '28',
  '34',
  '38',
  ...range(68, 104),
  ...range(125, 140),
  ...range(234, 251),
  ...range(288, 297),
]);

export function legacyVerbIdToVid(verbId: string): string | null {
  const raw = String(verbId ?? '').trim();
  if (!raw) return null;
  if (/^\d+$/.test(raw)) return raw;
  const normalized = raw.replace(/-/g, '_').toUpperCase();
  return EVENT_ID_BY_CODE[normalized] ?? null;
}

export function isKnownLegacyVerb(verbId: string): boolean {
  return legacyVerbIdToVid(verbId) !== null;
}

export function isLearnerRecordVerb(verbId: string): boolean {
  const vid = legacyVerbIdToVid(verbId);
  return vid !== null && LRS_VERB_IDS.has(vid);
}

function range(start: number, end: number): string[] {
  const values: string[] = [];
  for (let value = start; value <= end; value++) values.push(String(value));
  return values;
}
